import { CreateFunctionRequest, UpdateFunctionRequest } from '@beeboard/common';
import {
  checkAddCompanyFunction,
  checkRemoveCompanyFunction,
  checkUpdateCompanyFunction,
  canUserManageFunctions,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useFunctionStore } from './functionStore';
import { useProfileStore } from './profileStore';

export const useFunctionRulesStore = defineStore('functionRulesStore', {
  getters: {
    user() {
      return useProfileStore().profile;
    },
  },
  actions: {
    canUserManageFunctions() {
      return canUserManageFunctions(useProfileStore().profile.roles);
    },
    validateCreateFunctionRequest(payload: CreateFunctionRequest) {
      return checkAddCompanyFunction(payload, useFunctionStore().functions);
    },
    validateUpdateFunctionRequest(
      payload: UpdateFunctionRequest,
      functionId: string,
    ) {
      return checkUpdateCompanyFunction(
        payload,
        functionId,
        useFunctionStore().functions,
      );
    },
    validateRemoveFunctionRequest(functionId: string) {
      return checkRemoveCompanyFunction(
        functionId,
        useFunctionStore().functions,
      );
    },
  },
});
